import { Form, FormRenderProps } from 'react-final-form';
import { connect } from 'react-redux';
import { useCallback } from 'react';

import { Modal } from 'UIPackage/ModalModule/components/Modal';
import { ISelectOption } from 'UIPackage/MainModule/components/SelectInput';
import { Button } from 'UIPackage/MainModule/components/Button';
import { SelectInputField } from 'UIPackage/MainModule/components/SelectInputField';
import { UploadFileTypesEnum } from 'CorePackage/MainModule/enums/UploadFileTypesEnum';
import { ModalHeader } from 'UIPackage/ModalModule/components/ModalHeader';
import { ModalBody } from 'UIPackage/ModalModule/components/ModalBody';
import { ModalActions } from 'UIPackage/ModalModule/components/ModalActions';
import { FieldBlock } from 'UIPackage/FormModule/components/FieldBlock';
import { Row } from 'UIPackage/FormModule/components/Row';
import { IRootState } from 'CorePackage/MainModule/interfaces/IRootState';

import styles from './ImportFiltersModal.module.scss';
import { IImportFileStatus } from '../interfaces/IImportFileStatus';
import { getImportFilters } from '../selectors/importSelectors';
import { IImportFilters } from '../interfaces/IImportFilters';

export interface IFiltersModalForm {
  fileType: ISelectOption[];
  status: ISelectOption[];
}

interface IImportFiltersModalProps {
  visible?: boolean;
  fileTypes: Array<keyof typeof UploadFileTypesEnum>;
  statuses: IImportFileStatus[];
  onApply: (values: IFiltersModalForm) => void;
  onClose: () => void;
}

interface IImportFiltersModalStoreProps {
  values: IImportFilters;
}

const ImportFiltersModalWithoutStore = ({
  visible,
  fileTypes,
  statuses,
  values,
  onApply,
  onClose,
}: IImportFiltersModalProps & IImportFiltersModalStoreProps) => {
  const fileTypesSelectOptions = fileTypes.map(item => ({
    id: item,
    label: UploadFileTypesEnum[item],
    value: item,
  }));

  const statusesSelectOptions = statuses.map(item => ({
    id: item.id,
    label: item.name,
    value: item.id,
  }));

  const initialValues: IFiltersModalForm = {
    fileType: fileTypesSelectOptions,
    status: statusesSelectOptions.filter(item => values?.statuses.indexOf(item.value) !== -1),
  };

  const onSubmit = useCallback(
    (vals: IFiltersModalForm) => {
      onApply(vals);
      onClose();
    },
    [onApply, onClose],
  );

  let resetForm: () => void;

  function handleAfterClose() {
    resetForm?.();
  }

  function renderForm({ form, handleSubmit }: FormRenderProps<IFiltersModalForm>) {
    if (!resetForm && form && form.reset) {
      resetForm = form.reset;
    }

    return (
      <form onSubmit={handleSubmit}>
        <ModalHeader title="Фильтры" color="black" />
        <ModalBody size="content" border="bottom">
          <Row>
            <FieldBlock label="Тип загружаемого файла" labelFontSize="small">
              <SelectInputField id="fileType" name="fileType" options={fileTypesSelectOptions} isMulti />
            </FieldBlock>
          </Row>
          <Row>
            <FieldBlock label="Статус" labelFontSize="small">
              <SelectInputField id="status" name="status" options={statusesSelectOptions} isMulti />
            </FieldBlock>
          </Row>
        </ModalBody>
        <ModalActions>
          <Button color="primary" size="medium" text="Применить" type="submit" />
          <Button color="default" size="medium" text="Отменить" type="button" onClick={onClose} />
        </ModalActions>
      </form>
    );
  }

  return (
    <Modal visible={visible} modalBodyClassName={styles.Modal} onClose={onClose} afterClose={handleAfterClose}>
      <Form<IFiltersModalForm> initialValues={initialValues} onSubmit={onSubmit} render={renderForm} />
    </Modal>
  );
};

const mapStateToProps = (state: IRootState): IImportFiltersModalStoreProps => ({
  values: getImportFilters(state),
});

export const ImportFiltersModal = connect(mapStateToProps)(ImportFiltersModalWithoutStore);
